export default "__VITE_ASSET__DDm2fj8g__"